/** Python `date.weekday()` uses Monday=0 … Sunday=6; JS `Date.getDay()` uses Sunday=0 … Saturday=6. */

export function jsDayToPythonWeekday(jsDay: number): number {
    return (jsDay + 6) % 7
}

export function pythonWeekdayToJsDay(pythonWeekday: number): number {
    return (pythonWeekday + 1) % 7
}

export function jsWeekdaysToPython(jsWeekdays: number[]): number[] {
    return [...new Set(jsWeekdays.map(jsDayToPythonWeekday))].sort((a, b) => a - b)
}

export function pythonWeekdaysToJs(pythonWeekdays: number[]): number[] {
    return [...new Set(pythonWeekdays.map(pythonWeekdayToJsDay))].sort((a, b) => a - b)
}
